import { TicketClassCategory } from '../../constants';
import { CheckoutState } from '../../state';
import { getSelectedTickets } from './getSelectedTickets';

export const getNumberOfTicketsSelected = (state: CheckoutState) =>
    getSelectedTickets(state).reduce(
        (total, ticket) => total + ticket.selectedQuantity,
        0,
    );

export const getNumberOfDonationTicketsSelected = (state: CheckoutState) =>
    getSelectedTickets(state).reduce(
        (total, { selectedQuantity, category }) =>
            category === TicketClassCategory.donation
                ? total + selectedQuantity
                : total,
        0,
    );

export const getNumberOfAddonTicketsSelected = (state: CheckoutState) =>
    getSelectedTickets(state).reduce(
        (total, { selectedQuantity, category }) =>
            category === TicketClassCategory.addOn
                ? total + selectedQuantity
                : total,
        0,
    );

export const getNumberOfFreeTicketsSelected = (state: CheckoutState) =>
    getSelectedTickets(state).reduce(
        (total, { selectedQuantity, category, free }) =>
            category === TicketClassCategory.admission && free
                ? total + selectedQuantity
                : total,
        0,
    );

export const getNumberOfPaidTicketsSelected = (state: CheckoutState) =>
    getSelectedTickets(state).reduce(
        (total, { selectedQuantity, category, free }) =>
            category === TicketClassCategory.admission && !free
                ? total + selectedQuantity
                : total,
        0,
    );
